<div class="load">
    <div class="anima">      
    </div>
    <div class="logo">      
    </div>
</div>
